<template>
  <VDialog
    :open="isOpen"
    headline="Select Bot Variable"
    modal
    @close="handleCancel"
    :style="{ '--dialog-min-inline-size': '600px', '--dialog-max-inline-size': '900px', '--dialog-max-block-size': '650px' }"
  >
    <template #body>
      <div class="custom-field-picker-wrapper">
        <bot-variable-picker
          v-if="isOpen"
          :closeOnClickOutside="false"
          :openDropdownDefault="true"
          :light-background="lightBackground"
          @change="onChange"
          ref="pickerRef"
          :bot_id="bot_id"
          :canAddNew="true"
        />
      </div>
    </template>
  </VDialog>
</template>

<script setup>
import { ref } from 'vue';
import BotVariablePicker from './BotVariablePicker.vue';

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true
  },
  bot_id: {
    type: String,
    required: true
  },
  formattedOutput: {
    type: Boolean,
    default: true
  },
  lightBackground: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:isOpen', 'selected']);

const pickerRef = ref(null);

const onChange = (variable) => {
  props.formattedOutput ? emit('selected', `<bot_variable_${variable.name}>`) : emit('selected', `bot_variable_${variable.name}`);
  emit('update:isOpen', false);
};

const handleCancel = () => {
  emit('update:isOpen', false);
};
</script>

<style scoped>
.custom-field-picker-wrapper {
  position: relative;
  width: 100%;
  min-height: 400px;
  overflow-y: auto;
}
::v-deep(.dropdown-wrapper) {
  position: relative !important;
}
::v-deep(.title-wrapper) {
  display: none !important;
}
</style>
